import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import dayjs from "dayjs";

export const initialAssigneeLeadReportAPi = createApi({
    reducerPath: "leadReportApi",
    baseQuery: baseQueryWithAuth,
    tagTypes: ["initialAssignee"],
    endpoints: (builder) => ({
        getLeadReport: builder.query({
            query: ({ startDate, endDate, sr_managers, projectId, agents } = {}) => {

                const params = new URLSearchParams({
                    ...(startDate && { startDate: dayjs(startDate).format("YYYY-MM-DD") }),
                    ...(endDate && { endDate: dayjs(endDate).format("YYYY-MM-DD") }),
                    ...(sr_managers?.length > 0 && { sr_managers: sr_managers.join(",") }),
                    ...(projectId && { projectId }),
                    ...(agents?.length > 0 && { agents: agents.join(",") }),
                });

                return `${Apis.leadReport}?${params}`;
            },
        }),
        getReAssignedLeadReport: builder.query({
            query: ({ startDate, endDate, sr_managers } = {}) => {

                const params = new URLSearchParams({
                    ...(startDate && { startDate: dayjs(startDate).format("YYYY-MM-DD") }),
                    ...(endDate && { endDate: dayjs(endDate).format("YYYY-MM-DD") }),
                    ...(sr_managers?.length > 0 && { sr_managers: sr_managers.join(",") }),
                });

                return `${Apis.reAssignedLeadReport}?${params}`;
            },
        }),
    }),
});

export const { useLazyGetLeadReportQuery, useLazyGetReAssignedLeadReportQuery } = initialAssigneeLeadReportAPi;
